import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import Button from 'shared/components/button/Button';
import ProgressPhotosRow from './ProgressPhotosRow';
import {
  getClientProgressPhotos,
  getClientProgressPhotosFirst,
  PROGRESS_IMAGES_LIMIT
} from '../ducks/ProgressActions';

const ProgressPhotosHistory = ({
  clientId,
  getClientProgressPhotosFirst,
  getClientProgressPhotos,
  progressImages,
  lastImage
}) => {
  useEffect(() => {
    getClientProgressPhotosFirst(clientId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <div className="photos-history">
        {progressImages
          ? progressImages.map(progressImage => (
              <ProgressPhotosRow
                key={progressImage.assessment_id}
                date={progressImage.created_at}
                images={progressImage.images}
              />
            ))
          : 'No Images Yet'}
      </div>
      {!!lastImage && (progressImages.length >= PROGRESS_IMAGES_LIMIT) && (
        <div className="progress-load">
          <Button
            id=""
            type=""
            btnBlock=""
            btnSize=""
            color="secondary"
            label="Load More"
            onClick={() => getClientProgressPhotos(clientId, lastImage)}
          />
        </div>
      )}
    </div>
  );
};

function mapStateToProps(state) {
  return {
    progressImages: state.progressReducer.progressImages,
    lastImage: state.progressReducer.lastImage
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getClientProgressPhotosFirst: clientId =>
      dispatch(getClientProgressPhotosFirst(clientId)),
    getClientProgressPhotos: (clientId, last) =>
      dispatch(getClientProgressPhotos(clientId, last))
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProgressPhotosHistory);
